import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { NavParams, PopoverController } from '@ionic/angular';
import {ViewService} from "../../../services/common/view.service";
import {DataHistoryService} from "../../../services/common/dataHistory.service";
import {PositionGps} from "../../../classes/common/position-gps";

@Component({
  selector: 'app-popover-map-settings',
  templateUrl: './popover-map-settings.component.html',
  styleUrls: ['./popover-map-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PopoverMapSettingsComponent implements OnInit {
  private readonly maxStopMarkersMobile = 1500;

  @Input() opts: any = [
    {
      lbl: "POP_MAP_SETTINGS.show_poi",
      val: true,
    },
    {
      lbl: "POP_MAP_SETTINGS.show_vehicle_labels",
      val: false,
    },
    {
      lbl: "POP_MAP_SETTINGS.show_vehicle_plate",
      val: false,
    },

  ];

  @Input() map: any;


  // listener

  listener = {
    view: null
  };


  constructor(
    private cd: ChangeDetectorRef,
    private navParams: NavParams,
    private popoverCtrl: PopoverController,
    private view: ViewService,
    private dataHistory: DataHistoryService
  ) {
    // this.opts = this.navParams.get('options');
  }

  ngOnInit() {}

  ionViewWillEnter() {
  }

  ionViewDidEnter() {
    this.listenerView();
  }

  ionViewWillLeave() {
    if (this.listener.view) {
      this.listener.view.unsubscribe();
    }
  }

  ionViewDidLeave() {
  }

  async dismiss(action: string) {
    await this.popoverCtrl.dismiss({ action: action })
  }

  changeVal(option: any){
    switch (option.id){
      case 'showLabelNumber':
        this.map.toggleVisibilityLabel(option.val);
        break;
      case 'showName':
        this.map.toggleVisibilityPopup(option.val);
        break;
      case 'history_showArrows':
        if(option.val){
          this.map.drawArrows();
        }else{
          this.map.cleanArrows();
        }
        break;
      case 'history_showStops':
        if(option.val){
          const stopCount = this.countStopLegs(this.dataHistory.route);
          const currentLimit = stopCount > this.maxStopMarkersMobile ? this.maxStopMarkersMobile : undefined;
          this.map.drawStopMarkers(this.dataHistory.route, undefined, currentLimit);
        }else{
          this.map.cleanStopMarkers();
        }
        break;
      case 'autoResize':
        this.map.enableAutoFollow();
        this.dismiss('autoResize');
        break;
      case 'manualResize':
        this.map.disableAutoFollow();
        this.dismiss( 'manualResize')
        break;
      case 'center':
        this.dismiss( 'center')
        break;
    }
  }


  // listener

  /* listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      // console.log("listener.view", obj);

      // this.zone.run(() => {

      this.view.pipeChanged++;
      this.cd.markForCheck();

      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);

      // });
    });
  } */
  listenerView() {
    this.listener.view = ViewService.updateView$.subscribe((obj?: any) => {
      this.view.pipeChanged++;
      this.cd.markForCheck();
      setTimeout(() => {
        this.cd.markForCheck();
      }, 250);
    });
  }

  private countStopLegs(route: PositionGps[]): number {
    if(!route?.length) return 0;
    let count = 0;
    for(let i = 0; i < route.length; i++){
      if(route[i]?.pathType === 'stop') count++;
    }
    return count;
  }
















}
